import React from 'react';
import { motion } from 'framer-motion';
import { appScreensImage, howItWorks } from '../data/content';
import { Eyebrow, Heading, Section } from './Primitives';
export function Solution() {
  return <Section className="bg-cream" ariaLabel="How Pawsy Companion works" data-id="element-212" data-mp="10tpfbkzxil55">
      <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-213" data-mp="15sahvr2nlgwr">
        <div data-id="element-214" data-mp="15q65ekqov9kv">
          <Eyebrow align="left" data-id="element-215" data-mp="15pxsisukg49o">Meet Pawsy Companion</Eyebrow>
          <Heading data-id="element-216" data-mp="qu8af5si4ba8">One personalized plan. Built around YOUR dog.</Heading>
          <p className="mt-5 text-lg leading-relaxed text-ink-500" data-id="element-217" data-mp="vucut6wj5q5q">
            Tell Pawsy your dog's age, weight, activity level and goal. Pawsy builds the guidance around them — not
            generic advice for dogs “this size.”
          </p>

          <ol className="mt-7 space-y-3" data-id="element-218" data-mp="mviryyslw3jq">
            {howItWorks.map((step, index) => <li key={step} className="flex items-center gap-3" data-id="element-219" data-mp="2c94bimkbd8z7" data-mpi={index}>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-white font-display text-sm font-bold text-orangey-500 shadow-soft" data-id="element-220" data-mp="2h6edf1ow3d3x">
                  {index + 1}
                </span>
                <span className="font-semibold text-ink-700" data-id="element-221" data-mp="2yneb2cwjpuv">{step}</span>
              </li>)}
          </ol>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 22
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.55,
        ease: 'easeOut'
      }} className="overflow-hidden rounded-3xl border border-orangey-100 bg-white shadow-card" data-id="element-222" data-mp="gsegfpob07gk">
          <img src={appScreensImage} alt="Three phone screens showing the Pawsy Companion dashboard, daily routine checklist, and guides library" loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-223" data-mp="3u5zlcok2mmx2" />
        </motion.div>
      </div>
    </Section>;
}